<ng-container *ngIf="disabledChooseMotiveModal">
  <div *ngIf="isCropping">
    <ui-choose-motive-section
      (onSubmit)="onImageCropped($event)"
      [maxImageSize]="maxImageSize"
      (onClose)="isCropping = false; activePrinting?.url ? null : selectNo()"
      [imgUrl]="activePrinting?.url">
    </ui-choose-motive-section>
  </div>
  <div *ngIf="!isCropping">
    <div *ngFor="let option of options; let last=last"
         [class.mb-3]="!last">
      <label class="radio-item radio-primary"
             [class.checked]="option.id === activePrinting?.id">
        <input type="radio"
               [value]="option.id"
               name="motive"
               required
               [formControl]="optionControl"
        />
        <span>{{option.name}}</span>
      </label>
    </div>

    <div><!--<div [ngBusy]="{busy: imageUploading, message: ('common.pleaseWait' | translate)}">-->
      <div class="mt-3"
           [hidden]="!activePrinting?.id || !activePrinting?.url">
        <div *ngIf="activePrinting?.id || activePrinting?.url" class="image-container">
          <img [src]="activePrinting?.url"
               [alt]=""
               class="img-fluid pointer motive-image"
               (click)="isCropping = true"/>
        </div>
        <div class="mt-2">
          <button class="btn btn-link text-primary ps-0"
                  (click)="cancel(); isCropping = true;">
            <span [translate]="'cakeBuilder.cakeMotiveSection.chooseNew'"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!disabledChooseMotiveModal">
  <div *ngFor="let option of options; let last=last"
       [class.mb-3]="!last">
    <label class="radio-item radio-primary"
           [class.checked]="option.id === activePrinting?.id">
      <input type="radio"
             [value]="option.id"
             name="motive"
             required
             [formControl]="optionControl"
      />
      <span>{{option.name}}</span>
    </label>
  </div>

  <div><!--<div [ngBusy]="{busy: imageUploading, message: ('common.pleaseWait' | translate)}">-->
    <div class="mt-3"
         [hidden]="!activePrinting?.id || !activePrinting?.url">
      <div *ngIf="activePrinting?.id || activePrinting?.url" class="image-container">
        <img [src]="activePrinting?.url"
             class="img-fluid pointer motive-image"
             (click)="showMotiveModal(activePrinting?.url)"/>
      </div>
      <div class="mt-2">
        <button class="btn btn-link text-primary ps-0"
                (click)="cancel(); showMotiveModal();">
          <span [translate]="'cakeBuilder.cakeMotiveSection.chooseNew'"></span>
        </button>
      </div>
    </div>
  </div>
</ng-container>
